import React from "react";
import { Card } from "react-bootstrap";

function RefundPolicyScreen() {
  return (
    <div>
      <h2 style={{ color: "#0a5a6a" }}>Cancellation & Refund Policy</h2>
      zutle is a product of zpotter technoglies.
      <br />
      <br />
      <Card
        style={{
          marginTop: "2rem",
          padding: "2rem",
          backgroundColor: "transparent",
          fontSize: "0.9rem",
        }}
      >
        <div>
          <h5 style={{ color: "#0a5a6a" }}>
            Last updated on 24-04-2025 17:12:05
          </h5>
          <p>
            ZPOTTER TECHNOLOGIES believes in helping its customers as far as
            possible, and has therefore a liberal cancellation policy. Under
            this policy: • Cancellations will be considered only if the request
            is made immediately after placing the order. However, the
            cancellation request may not be entertained if the orders have been
            communicated to the vendors/merchants and they have initiated the
            process of shipping them. • ZPOTTER TECHNOLOGIES does not accept
            cancellation requests for perishable items like flowers, eatables
            etc. However, refund/replacement can be made if the customer
            establishes that the quality of product delivered is not good. • In
            case of receipt of damaged or defective items please report the same
            to our Customer Service team. The request will, however, be
            entertained once the merchant has checked and determined the same at
            his own end. This should be reported within Only same day days of
            receipt of the products. In case you feel that the product received
            is not as shown on the site or as per your expectations, you must
            bring it to the notice of our customer service within Only same day
            days of receiving the product. The Customer Service Team after
            looking into your complaint will take an appropriate decision. • In
            case of complaints regarding products that come with a warranty from
            manufacturers, please refer the issue to them. In case of any
            Refunds approved by the ZPOTTER TECHNOLOGIES, it will take 4 to 5
            working days for the refund to be processed to the end customer.
          </p>
        </div>
      </Card>
    </div>
  );
}

export default RefundPolicyScreen;
